import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FirebaseService } from '../../../service/firebase.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-data-display',
  templateUrl: './data-display.component.html',
  styleUrls: ['./data-display.component.scss']
})
export class DataDisplayComponent implements OnInit {
  cvNumber: number = 0;
  cvPrint: number = 0;
  cvEmail: number = 0;
  cvNumberAll: number = 0;
  cvPrintAll: number = 0;
  cvEmailAll: number = 0;

  @Input('displayDataSources') displayDataSources: any;

  constructor(private _firebase: FirebaseService) { }

  ngOnInit(): void {

    this.initData()
  }

  exportAllData() {

   // this.displayDataSources.forEach()
   /* data.forEach(item => {
      for (var property in item) {
        if (isArray(item[property]))
          item[property] = item[property].join();
      }

    })*/    this._firebase.getAllDataFromUser(this._firebase.user.uid).then(d => {
      let allData = d.docs.map(v => v.data())
      let res = [];
      allData.forEach(item => {
        let elem = {};
        item.data.forEach((val) => {
          elem[val.name] = val.value
        })

        res.push(elem)
      })


    //  console.log(res)
      let ws = XLSX.utils.json_to_sheet(res);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
      XLSX.writeFile(wb, `data-all-cv-${new Date().getTime()}.xlsx`)
    })

  /*  */
  }

  initData() {
    this.displayDataSources.forEach((sources, index) => {

      this.cvNumber += sources.filteredData.length

      sources.filteredData.forEach(item => {
        //    console.log(item)
        if (item['Envoi par email'] == 'OUI') {
          this.cvEmail++;
        }
        if (item['Impression'] == 'OUI') {
          this.cvPrint++;
        }
      })
    })
// console.log(this.cv)

    this._firebase.getAllDataFromUser(this._firebase.user.uid).then(d => {
      //console.log();

      let data = d.docs.map(v => v.data())


      this.cvNumberAll = data.length;

      data.forEach((item) => {
        item.data.forEach((elem) => {
          if (elem.name == 'Envoi par email' && elem.value == 'OUI') {
            this.cvEmailAll++;
          }
          if (elem.name == 'Impression' && elem.value == 'OUI') {
            this.cvPrintAll++;
          }

        })


       /* if (item.data['Envoi par email'] == 'OUI')
          this.cvEmailAll++;
        if (item.data['Impression'] == 'OUI') {
          this.cvPrintAll++;
        }*/
      })

    })


  }


}
